module.exports = __webpack_public_path__ + "img/web.25ea3cc5.png";